import {BaseConverter} from "../../base/converters/base-converter.converter";
import {DataForReviewModel} from "../models/data-for-review.model";
import {DataForReview} from "../DTO/dataForReview";
import {Injectable} from "@angular/core";

@Injectable()
export class DataForReviewConverter extends BaseConverter<DataForReviewModel, DataForReview> {
  convertToDto(model: DataForReviewModel): DataForReview {
    if (!model) {
      return;
    }
    return {
      operation: model.operation,
      dataFromWarp: model.dataFromWarp
    };
  }

  convertToModel(dto: DataForReview): DataForReviewModel {
    if (!dto) {
      return;
    }
    let model: DataForReviewModel = new DataForReviewModel();
    model.dataFromWarp = dto.dataFromWarp;
    model.operation = dto.operation;
    return model;
  }

}
